/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesModule } from 'primeng/messages';
import { SharedModule } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { translationSchema } from '@well/translation';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';

@Component({
  selector: 'well-office-address-info-message',
  standalone: true,
  imports: [MessageModule, CommonModule, MessagesModule, SharedModule, TranslateModule, SharedComponentsModule],
  templateUrl: './office-address-info-message.component.html',
  styleUrl: './office-address-info-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfficeAddressInfoMessageComponent {
  protected readonly translationSchema = translationSchema;
}
